export const NO_DATA_LABEL = 'NA';
export const PREC_VALUE_THRESHOLD = 0.9;
